export { default } from './ItemField';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/ItemField/index.js